import { renderTabsByDataset } from "../../util/tabs/tabs-render";
import type { RankingMonthlyTabType } from "./rankings-monthly-tabs-form";

export class RankingsMonthlyTabsRender {
    public static renderTypeActive(tabs: HTMLElement[], panels: HTMLElement[], type: RankingMonthlyTabType): void {
        renderTabsByDataset(tabs, panels, "rankingType", type);
    }

    public static renderParentActive(tabs: HTMLElement[], panels: HTMLElement[], parentCategoryId: string): void {
        renderTabsByDataset(tabs, panels, "parentCategoryId", parentCategoryId);
    }
}
